export default {
  getLoading: state => state.loading,
  getTypeOfferFormSelected: state => state.typeOfferFormSelected,
  getIsFromEditing: state => state.isFromEditing
}
